var React = require('react');

function Smile (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#1236ff;}")),React.createElement("title",{"key":1},":)"),React.createElement("path",{"className":"a","d":"M65.28,32.18,54.64,24.57a2.05,2.05,0,0,0-2.38,3.34l4.1,2.93C54.07,37.3,46.13,48.38,33.07,48.38c-12.19,0-20.2-10.89-23.17-17.55L14,28a2,2,0,0,0-2.33-3.37L6.1,28.47,6,28.52.88,32.08a2,2,0,0,0,2.33,3.37L6.5,33.18c3.76,7.67,12.93,19.3,26.57,19.3,14.37,0,23.47-11.72,26.71-19.19l3.11,2.23a2.1,2.1,0,0,0,1.19.38,2.05,2.05,0,0,0,1.2-3.72Z","key":2}),React.createElement("ellipse",{"className":"a","cx":"22.82","cy":"11.1","rx":"5.89","ry":"11.1","key":3}),React.createElement("ellipse",{"className":"a","cx":"43.31","cy":"11.1","rx":"5.89","ry":"11.1","key":4})]);
}

Smile.defaultProps = {"viewBox":"0 0 66.13 52.48"};

module.exports = Smile;

Smile.default = Smile;
